  
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const Notice = () => {
  const [users, setUser] = useState([]);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    const result = await axios.get("https://ebandhu-7a8e5.firebaseio.com/students-list");
    setUser(result.data.reverse());
  };

  const deleteUser = async id => {
    await axios.delete(`https://ebandhu-7a8e5.firebaseio.com/students-list/${id}`);
    loadUsers();
  };

  return (
    <div className="container">
      <div className="py-4">
        <h1>Home Page</h1>
        <table class="table border shadow">
          <thead class="thead-dark">
            <tr>
              <th scope="col">fullname</th>
              <th scope="col">Email</th>
              <th scope="col">phone</th>
              <th scope="col">Education</th>
              <th scope="col">Email</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <tr>
                <th scope="row">{index + 1}</th>
                <td>{user.fullname}</td>
                <td>{user.phone}</td>
                <td>{user.email}</td>
                <td>
                  <Link class="btn btn-primary mr-2" to={`/users/${user.id}`}>
                    View
                  </Link>
                  <Link
                    class="btn btn-outline-primary mr-2"
                    to={`/users/edit/${user.id}`}
                  >
                    Edit
                  </Link>
                  <Link
                    class="btn btn-danger"
                    onClick={() => deleteUser(user.id)}
                  >
                    Delete
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Notice;